import { isConfigFlagEnabled } from '../config';
import { addMessageBox } from '../redux/actions/messageBoxesActions';
import { ALL_POKER_VARIANT_PROPERTIES } from '../types/pokerVariantTypes';
export function validateSupportedPokerVariantIdOrShowError(isAllInGame, dispatch) {
    if (isAllInGame && !isConfigFlagEnabled('allInGames')) {
        dispatch(addMessageBox({ type: 'basic', title: 'Sorry, all-in games are not supported in this client.' }));
        return false;
    }
    return true;
}
/**
 * Return true if variant supports pot-limit and only pot-limit.
 */
export function isVariantPotLimit(pokerVariant) {
    const { availableLimitTypes } = ALL_POKER_VARIANT_PROPERTIES[pokerVariant];
    return availableLimitTypes.includes('pot-limit') && availableLimitTypes.length === 1;
}
